module.exports = function getResource(label, vars = []) {
    let resources = {
        placeholderUs: 'Inscrire code postal ou ZIP',
        placeholderCa: 'Inscrire code postal',
        placeholderOnline: 'Exclusivité en ligne',
        messageEmpty: 'Code postal ou Zip non valide.',
        messageInvalid: 'Code postal/Zip non valide.'
    };
    return resources[label];
};
